import Beneficiary from './Beneficiary.container'
export default Beneficiary
